// utils/calculateProfileCompletion.js
export const calculateProfileCompletion = (jobseeker) => {
    const sections = [
        {
            name: 'aboutMe',
            fields: ['first_name', 'last_name', 'working_title', 'description'],
        },
        {
            name: 'personalInformation',
            fields: ['first_name', 'last_name', 'birth_date', 'gender', 'nationality', 'country', 'languages'],
        },
        {
            name: 'workExperience',
            fields: ['work_experiences'],
        },
        {
            name: 'education',
            fields: ['education'],
        },
        {
            name: 'skills',
            fields: ['skills'],
        },
        {
            name: 'occupations',
            fields: ['occupations'],
        },
        {
            name: 'resumeCoverLetter',
            fields: ['cv_file', 'cv_file_0', 'cv_file_1', 'cv_file_2', 'cv_file_3', 'cv_file_4'], // All cv_file fields
        },
        {
            name: 'certification',
            fields: ['certification'],
        },
        {
            name: 'portfolio',
            fields: ['portfolio'],
        },
        {
            name: 'jobPreferences',  // Added new section for job preferences
            fields: ['jobType', 'basePay', 'payPeriod', 'relocation', 'jobTitles']
        }
    ];

    let filledFields = 0;
    let totalFields = 0;
    sections.forEach((section) => {
        if (section.name === 'resumeCoverLetter') {
            // Only one of the cv_file_* fields needs to be checked
            totalFields += 1;
            const cvFileFound = section.fields.some((cvFileKey) => jobseeker[cvFileKey]);
            if (cvFileFound) {
                filledFields += 1;
            }
        }
        else if (section.name === 'certification') {
            totalFields += 1;
            // Check if there are certification
            if (jobseeker.certification && jobseeker.certification.length > 0) {
                filledFields += 1;
            }
        } else if (section.name === 'portfolio') {
            totalFields += 1;
            // Check if there are portfolio items
            if (jobseeker.portfolio && jobseeker.portfolio.length > 0) {
                filledFields += 1;
            }
        } else if (section.name === 'jobPreferences') {
            // Check each field in jobPreferences
            // section.fields.forEach((field) => {
            //     totalFields += 1;
            //     if (jobseeker?.jobPreferences && jobseeker?.jobPreferences?.length > 0 && jobseeker?.jobPreferences[0][field] && (Array.isArray(jobseeker?.jobPreferences[0][field]) ? jobseeker?.jobPreferences[0][field].length > 0 : jobseeker?.jobPreferences[0][field])) {
            //         filledFields += 1;
            //     }
            // });
        }
        else {
            section.fields.forEach((field) => {
                totalFields += 1;
                if (jobseeker[field] && (Array.isArray(jobseeker[field]) ? jobseeker[field].length > 0 : jobseeker[field])) {
                    filledFields += 1;
                }
            });
        }
    });
    return Math.round((filledFields / totalFields) * 100);
};

export const calculateEmployerProfileCompletion = (employer) => {
    const sections = [
        {
            name: 'companyDetails',
            fields: ['company_name', 'company_description', 'company_email_address', 'company_industries', 'company_size', 'company_website', 'country', 'state', 'city', 'postalCode', 'Address_Line_1', 'Address_Line_2','mobile_number'],
        },
        {
            name: 'contactInformation',
            fields: ['first_name', 'last_name', 'phone'],
        },
        {
            name: 'profileImage',
            fields: ['profile_image'],
        },
        {
            name: 'roleDetails',
            fields: ['role'],
        }
    ];

    let filledFields = 0;
    let totalFields = 0;

    sections.forEach((section) => {
        section.fields.forEach((field) => {
            totalFields += 1;
            if (employer[field] && (Array.isArray(employer[field]) ? employer[field].length > 0 : employer[field])) {
                filledFields += 1;
            }
        });
    });
     return Math.round((filledFields / totalFields) * 100);
};
export const calculateEmployerIndividualProfileCompletion = (employer) => {
    const sections = [
        {
            name: 'companyDetails',
            fields: [ 'country', 'state', 'city', 'postalCode', 'Address_Line_1', 'Address_Line_2','mobile_number'],
        },
        {
            name: 'contactInformation',
            fields: ['first_name', 'last_name',  ],
        },
        {
            name: 'profileImage',
            fields: ['profile_image'],
        },
        {
            name: 'roleDetails',
            fields: ['role'],
        }
    ];

    let filledFields = 0;
    let totalFields = 0;

    sections.forEach((section) => {
        section.fields.forEach((field) => {
            totalFields += 1;
            if (employer[field] && (Array.isArray(employer[field]) ? employer[field].length > 0 : employer[field])) {
                filledFields += 1;
            }
        });
    });
     return Math.round((filledFields / totalFields) * 100);
};